module.exports = __webpack_public_path__ + "static/scale-model-of-tampa-pier-in-tampa-florida-a1adf05e30df71de2823d72a3ba550a1.png";